// Change this
const module = 'bookings'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/bookings/Index'
import Create from '@/views/bookings/Create'
import Edit from '@/views/bookings/Edit'
import Test from '@/views/bookings/Test'
import Success from '@/views/bookings/Success'
import Cancel from '@/views/bookings/Cancel'
import Complete from '@/views/bookings/Complete'
import Management from '@/views/bookings/Management'

var prefix = '/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/test`,
        name: `${module}Test`,
        component: Test,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/success`,
        name: `${module}Success`,
        component: Success,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/cancel`,
        name: `${module}Cancel`,
        component: Cancel,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/complete`,
        name: `${module}Complete`,
        component: Complete,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}-management`,
        name: `${module}Management`,
        component: Management,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
